 <template>
	<div class="window">
        <div class="header"><span v-html="translation.kup"></span></div>
        <div class="description-box">
            <img src="../assets/unlock.gif" />
            <div class="line1" v-html="translation.odkryj_dostep"></div>    
            <div class="line2" v-html="translation.odkryj_dostep_opis"></div>
        
            <button class="btn btn-all btn-gold"  @click="buyGame" v-html="translation.kup"></button>

            <a class="back-screen" @click="backToContinue">
                <chevron-left-icon class="icon" /><span v-html="translation.back"></span>
            </a>

        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
//import axios from 'axios'
import {  ChevronLeftIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'KupGre',
    props: {
        language: String
    },
    components: { 
        ChevronLeftIcon
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            errorMessage: '',
            theme: localStorage.getItem('theme'),
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    methods: {
        backToContinue() {
            this.$emit('go-to-plansza-poziomow')
        },
        buyGame() {
            localStorage.setItem('alreadypaid','yes');
            this.$emit('dokonaj-oplacenia');
            this.$emit('on-change-bottom-message', this.translation.odblokowane);
            setTimeout(function() {
                this.$emit('on-change-bottom-message', '');
                this.$emit('go-to-plansza-poziomow');
            }.bind(this), 2000);
        }
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
            this.getQuestion()
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

.mt2x {
    margin-top: 2em;
}

.line1,
.line2 {
    font-size: 22px;
    margin-bottom: 0.5em;
}
.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}

.btn-gold {
    background-color: var(--bs-gold);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}

</style>
